<template>
<v-flex>
    <h1 style="color: #969462 !important;">Clientes</h1>
    <div class="elevation-3">
        <v-dialog v-model="loader" persistent width="350">
            <v-card color="#969462" dark>
                <v-card-text>
                    Esta operação pode demorar alguns minutos.<br>
                    Por favor aguarde...
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <div class="tableHeader">
            <v-dialog persistent v-model="modal" max-width="500px">
                <v-btn slot="activator" color="#969462" dark class="mb-2">
                    <v-icon class="buttonIconText" color="white">playlist_add</v-icon> Novo {{name}}
                </v-btn>
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>
                    <v-form ref="form" v-on:submit.prevent>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm12 md12>
                                        <label class="label-modal">Nome</label>
                                        <v-text-field color="#969462" :autofocus="true" :rules="defaultRules" v-model="editedItem.nome"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <label class="label-modal">Email</label>
                                        <v-text-field color="#969462" :rules="defaultRules" v-model="editedItem.email"></v-text-field>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                        <label class="label-modal">Escritório</label>
                                        <v-select color="#969462" v-model="editedItem.id_escritorio" :rules="defaultRules" :items="getEscritorios" item-text="nome" item-value="id_escritorio"></v-select>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                        <label class="label-modal">Telefone</label>
                                        <v-text-field color="#969462" :rules="defaultRules" v-model="editedItem.telefone"></v-text-field>
                                    </v-flex>
                                    <v-flex xs4 sm4 md4>
                                        <label class="label-modal">Código</label>
                                        <v-text-field color="#969462" :rules="defaultRules" v-model="editedItem.codigo"></v-text-field>
                                    </v-flex>
                                    <v-flex xs4 sm4 md4>
                                        <label class="label-modal">NIF</label>
                                        <v-text-field color="#969462" :rules="defaultRules" v-model="editedItem.nif"></v-text-field>
                                    </v-flex>
                                    <v-flex xs4 sm4 md4>
                                        <label class="label-modal">Ano inicio</label>
                                        <v-text-field color="#969462" :rules="defaultRules" v-model="editedItem.ano"></v-text-field>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                        <label class="label-modal">URL Website</label>
                                        <v-text-field color="#969462" v-model="editedItem.urlwebsite"></v-text-field>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                        <label class="label-modal">2 anos relatório de gestão?</label>
                                        <v-radio-group v-model="editedItem.anos2" :mandatory="true" row>
                                            <v-radio color="#969462" label="Sim" :value="1"></v-radio>
                                            <v-radio color="#969462" label="Não" :value="0"></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <label class="label-modal">Pastas a ignorar</label>
                                        <v-text-field color="#969462" v-model="editedItem.pastas"></v-text-field>
                                    </v-flex>
                                    <v-flex v-if="editedIndex==-1" xs12 sm12 md12>
                                            <label class="label-modal">Password</label>
                                            <v-text-field color="#969462" type="password" :rules="defaultRules" v-model="editedItem.password" append-icon="cached" @click:append="gerarPassword()"></v-text-field>
                                        </v-flex>
                                        <v-flex v-if="editedIndex==-1" xs12 sm12 md12>
                                            <label class="label-modal">Confirmar password</label>
                                            <v-text-field color="#969462" :rules="pwdRules" v-model="cpwd" :type="show ? 'text' : 'password'" @click:append="show = !show" :append-icon="!show ? 'visibility' : 'visibility_off'"></v-text-field>
                                        </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="#969462" flat @click.native="close">Cancelar</v-btn>
                            <v-btn color="#969462" flat @click.native="save">Guardar</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>

            <v-text-field color="#969462" class="searchTable" v-model="search" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
        </div>

        <v-dialog persistent v-model="deleteM" max-width="390">
            <v-card>
                <v-card-title class="headline" style="margin-left: 0px !important;">Apagar {{name}}</v-card-title>
                <v-card-text>De certeza que quer apagar este {{name}}?</v-card-text>
                <v-card-actions style="margin-top: 0px !important;">
                    <v-spacer></v-spacer>
                    <v-btn color="#969462" flat="flat" @click.native="close">Cancelar</v-btn>
                    <v-btn color="#969462" flat="flat" @click.native="save">Apagar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="email" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">Enviar email</span>
                </v-card-title>
                <v-form ref="formEmail" v-on:submit.prevent>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 sm12 md12>
                                    <label class="label-modal">Email</label>
                                    <v-text-field color="#969462" :rules="defaultRules" v-model="E.email"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                    <label class="label-modal">Assunto</label>
                                    <v-text-field color="#969462" :rules="defaultRules" v-model="E.assunto"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                    <label class="label-modal">Corpo</label>
                                    <v-textarea rows="5" color="#969462" :rules="defaultRules" v-model="E.corpo"></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#969462" flat @click.native="email=false">Cancelar</v-btn>
                        <v-btn color="#969462" flat @click.native="sendMail">Enviar</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="form" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">Parâmetros de pesquisa</span>
                </v-card-title>
                <v-form ref="formS" v-on:submit.prevent>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs6 sm6 md6>
                                    <label class="label-modal">Ano</label>
                                    <v-autocomplete color="#969462" :items="editedItem.anos" v-model="ano"></v-autocomplete>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                    <label class="label-modal">Mês</label>
                                    <v-autocomplete color="#969462" :items="meses" v-model="mes" item-text="nome" item-value="mes"></v-autocomplete>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#969462" flat @click.native="close">Cancelar</v-btn>
                        <v-btn color="#969462" flat @click.native="gerar">Confirmar</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
            <v-card v-if="editedIndex > -1">
                <v-toolbar dark color="#969462">
                    <v-btn icon dark @click="dialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{editedItem.nome}} - Relatório de Gestão - {{ano}}/{{meses.find((el)=>{ return el.mes == mes }).nome}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items style="display: flex !important; align-items: center !important;">
                        <v-btn v-if="path==null" color="white" flat @click="exportar()">Exportar</v-btn>
                        <a v-if="path!=null" target="_blank" :href="path">{{path}}</a>
                        <v-tooltip v-if="path!=null" bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon color="white" v-on="on" @click="email=true">send</v-icon>
                            </template>
                            <span>Enviar e-mail</span>
                        </v-tooltip>
                    </v-toolbar-items>
                </v-toolbar>

                <v-card id="report" style="display: flex; margin-top: 50px; justify-content: center; box-shadow: none !important;">
                    <v-layout row wrap style="display: flex; justify-content: center;">

                        <v-flex xs10 sm10 md10 pb-5>
                            <div id="P1">
                                <p class="r-header">
                                    <v-icon>arrow_forward_ios</v-icon> Até ao final de <span class="bold-up"> {{meses.find((el)=>{ return el.mes == mes }).nome}} </span> de <span class="bold-up"> {{ano}} </span> a empresa <span class="bold-up"> {{editedItem.nome}} </span>:
                                </p>
                                <p class="r-child">
                                    <v-icon>lens</v-icon> Gerou um volume de negócios de: <span class="bold-up"> € {{numberWithSpaces(VALUES.P1.volnegocios)}}</span>
                                </p>
                                <p class="r-child">
                                    <v-icon>lens</v-icon> Registou uma margem bruta de: <span class="bold-up"> € {{numberWithSpaces(VALUES.P1.margembruta)}}</span>
                                </p>
                                <p class="r-child">
                                    <v-icon>lens</v-icon> Apresentou um resultado antes de impostos de: <span class="bold-up"> € {{numberWithSpaces(T1T3A)}}</span>
                                </p>
                                <p class="r-child">
                                    <v-icon>lens</v-icon> Gerou um EBIDTA (Cash Flow Operacional) de: <span class="bold-up"> € {{numberWithSpaces(T1T1A)}}</span>
                                </p>
                            </div>
                        </v-flex>

                        <v-flex xs10 sm10 md10 pb-5>
                            <div id="P2">
                                <p class="r-header">
                                    <v-icon>arrow_forward_ios</v-icon> Contingências Fiscais:
                                </p>

                                <v-edit-dialog large persistent save-text="Guardar" cancel-text="Cancelar" :return-value.sync="STRINGS[1]">
                                    <p class="r-child">
                                        <v-icon>lens</v-icon> {{ STRINGS[1] }}
                                    </p>
                                    <template v-slot:input>
                                        <v-textarea autofocus color="#969462" v-model="STRINGS[1]" rows="6"></v-textarea>
                                    </template>
                                </v-edit-dialog>

                                <v-edit-dialog large persistent save-text="Guardar" cancel-text="Cancelar" :return-value.sync="STRINGS[2]">
                                    <p class="r-child">
                                        <v-icon>lens</v-icon> {{ STRINGS[2] }}
                                    </p>
                                    <template v-slot:input>
                                        <v-textarea autofocus color="#969462" v-model="STRINGS[2]" rows="6"></v-textarea>
                                    </template>
                                </v-edit-dialog>

                                <v-edit-dialog large persistent save-text="Guardar" cancel-text="Cancelar" :return-value.sync="STRINGS[3]">
                                    <p class="r-child">
                                        <v-icon>lens</v-icon> {{ STRINGS[3] }}
                                    </p>
                                    <template v-slot:input>
                                        <v-textarea autofocus color="#969462" v-model="STRINGS[3]" rows="6"></v-textarea>
                                    </template>
                                </v-edit-dialog>

                                <v-edit-dialog large persistent save-text="Guardar" cancel-text="Cancelar" :return-value.sync="STRINGS[4]">
                                    <p class="r-child">
                                        <v-icon>lens</v-icon> {{ STRINGS[4] }}
                                    </p>
                                    <template v-slot:input>
                                        <v-textarea autofocus color="#969462" v-model="STRINGS[4]" rows="6"></v-textarea>
                                    </template>
                                </v-edit-dialog>

                                <v-edit-dialog large persistent save-text="Guardar" cancel-text="Cancelar" :return-value.sync="STRINGS[5]">
                                    <p class="r-child">
                                        <v-icon>lens</v-icon> {{ STRINGS[5] }}
                                    </p>
                                    <template v-slot:input>
                                        <v-textarea autofocus color="#969462" v-model="STRINGS[5]" rows="6"></v-textarea>
                                    </template>
                                </v-edit-dialog>
                            </div>
                        </v-flex>

                        <v-flex xs10 sm10 md10 pb-5>
                            <div id="T1">
                                <table width="100%" style="text-align: right;">
                                    <tr>
                                        <th width="50%" colspan="1">Demonstração de resultados por natureza da empresa {{editedItem.nome}} em {{meses.find((el)=>{ return el.mes == mes }).nome}} de {{ano}}</th>
                                        <th width="50%" colspan="4">Períodos</th>
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <th :colspan="editedItem.anos2 ? '1' : '4'">{{Number(ano)}}</th>
                                        <th v-if="editedItem.anos2">{{(Number(ano) - 1)}}</th>
                                        <th v-if="editedItem.anos2">&Delta;</th>
                                        <th v-if="editedItem.anos2">&Delta;%</th>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Rendimentos e gastos</td>
                                        <td colspan="4"></td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Vendas e serviços prestados</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '4'">
                                            <v-edit-dialog :return-value.sync="VALUES.T1A.vendasservicosprestados">
                                                {{ numberWithSpaces(VALUES.T1A.vendasservicosprestados) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1A.vendasservicosprestados" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T1B.vendasservicosprestados">
                                                {{ numberWithSpaces(VALUES.T1B.vendasservicosprestados) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1B.vendasservicosprestados" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(getDiffT1('vendasservicosprestados').replace('-',''))}}</td>
                                        <td v-if="editedItem.anos2">{{getPercentT1('vendasservicosprestados')}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Subsídios à exploração</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '4'">
                                            <v-edit-dialog :return-value.sync="VALUES.T1A.subsidiosaexploracao">
                                                {{ numberWithSpaces(VALUES.T1A.subsidiosaexploracao) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1A.subsidiosaexploracao" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T1B.subsidiosaexploracao">
                                                {{ numberWithSpaces(VALUES.T1B.subsidiosaexploracao) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1B.subsidiosaexploracao" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(getDiffT1('subsidiosaexploracao').replace('-',''))}}</td>
                                        <td v-if="editedItem.anos2">{{getPercentT1('subsidiosaexploracao')}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Variação nos inventários da produção</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '4'">
                                            <v-edit-dialog :return-value.sync="VALUES.T1A.variacaoinventariosprod">
                                                {{ numberWithSpaces(VALUES.T1A.variacaoinventariosprod) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1A.variacaoinventariosprod" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T1B.variacaoinventariosprod">
                                                {{ numberWithSpaces(VALUES.T1B.variacaoinventariosprod) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1B.variacaoinventariosprod" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(getDiffT1('variacaoinventariosprod').replace('-',''))}}</td>
                                        <td v-if="editedItem.anos2">{{getPercentT1('variacaoinventariosprod')}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Trabalhos para a própria entidade</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '4'">
                                            <v-edit-dialog :return-value.sync="VALUES.T1A.trabalhospropriaentidade">
                                                {{ numberWithSpaces(VALUES.T1A.trabalhospropriaentidade) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1A.trabalhospropriaentidade" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T1B.trabalhospropriaentidade">
                                                {{ numberWithSpaces(VALUES.T1B.trabalhospropriaentidade) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1B.trabalhospropriaentidade" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(getDiffT1('trabalhospropriaentidade').replace('-',''))}}</td>
                                        <td v-if="editedItem.anos2">{{getPercentT1('trabalhospropriaentidade')}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Custos das mercadorias vendidas e das matérias consumidas</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '4'">
                                            <v-edit-dialog :return-value.sync="cmvcmcA">
                                                {{ numberWithSpaces(cmvcmcA) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="cmvcmcA" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="cmvcmcB">
                                                {{ numberWithSpaces(cmvcmcB) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="cmvcmcB" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(getDiffT1('cmvcmc').replace('-',''))}}</td>
                                        <td v-if="editedItem.anos2">{{getPercentT1('cmvcmc')}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Fornecimentos e serviços externos</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '4'">
                                            <v-edit-dialog :return-value.sync="VALUES.T1A.fse">
                                                {{ numberWithSpaces(VALUES.T1A.fse) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1A.fse" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T1B.fse">
                                                {{ numberWithSpaces(VALUES.T1B.fse) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1B.fse" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(getDiffT1('fse').replace('-',''))}}</td>
                                        <td v-if="editedItem.anos2">{{getPercentT1('fse')}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Gastos com o pessoal</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '4'">
                                            <v-edit-dialog :return-value.sync="VALUES.T1A.gastoscompessoal">
                                                {{ numberWithSpaces(VALUES.T1A.gastoscompessoal) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1A.gastoscompessoal" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T1B.gastoscompessoal">
                                                {{ numberWithSpaces(VALUES.T1B.gastoscompessoal) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1B.gastoscompessoal" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(getDiffT1('gastoscompessoal').replace('-',''))}}</td>
                                        <td v-if="editedItem.anos2">{{getPercentT1('gastoscompessoal')}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Imparidade (perdas/reversões)</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '4'">
                                            <v-edit-dialog :return-value.sync="VALUES.T1A.imparidade">
                                                {{ numberWithSpaces(VALUES.T1A.imparidade) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1A.imparidade" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T1B.imparidade">
                                                {{ numberWithSpaces(VALUES.T1B.imparidade) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1B.imparidade" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(getDiffT1('imparidade').replace('-',''))}}</td>
                                        <td v-if="editedItem.anos2">{{getPercentT1('imparidade')}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Provisões (aumentos/reduções)</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '4'">
                                            <v-edit-dialog :return-value.sync="VALUES.T1A.provisoes">
                                                {{ numberWithSpaces(VALUES.T1A.provisoes) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1A.provisoes" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T1B.provisoes">
                                                {{ numberWithSpaces(VALUES.T1B.provisoes) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1B.provisoes" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(getDiffT1('provisoes').replace('-',''))}}</td>
                                        <td v-if="editedItem.anos2">{{getPercentT1('provisoes')}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Outros rendimentos e ganhos</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '4'">
                                            <v-edit-dialog :return-value.sync="VALUES.T1A.outrosrendimentosganhos">
                                                {{ numberWithSpaces(VALUES.T1A.outrosrendimentosganhos) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1A.outrosrendimentosganhos" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T1B.outrosrendimentosganhos">
                                                {{ numberWithSpaces(VALUES.T1B.outrosrendimentosganhos) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1B.outrosrendimentosganhos" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(getDiffT1('outrosrendimentosganhos').replace('-',''))}}</td>
                                        <td v-if="editedItem.anos2">{{getPercentT1('outrosrendimentosganhos')}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Outros gastos e perdas</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '4'">
                                            <v-edit-dialog :return-value.sync="VALUES.T1A.outrosgastosperdas">
                                                {{ numberWithSpaces(VALUES.T1A.outrosgastosperdas) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1A.outrosgastosperdas" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T1B.outrosgastosperdas">
                                                {{ numberWithSpaces(VALUES.T1B.outrosgastosperdas) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1B.outrosgastosperdas" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(getDiffT1('outrosgastosperdas').replace('-',''))}}</td>
                                        <td v-if="editedItem.anos2">{{getPercentT1('outrosgastosperdas')}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-right">Resultados antes de depreciações, gastos de financiamento e impostos</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '4'"><b>{{numberWithSpaces(T1T1A)}}</b></td>
                                        <td v-if="editedItem.anos2"><b>{{numberWithSpaces(T1T1B)}}</b></td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(getDiffTotal('1'))}}</td>
                                        <td v-if="editedItem.anos2">{{(getPercentTotal('1'))}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Gastos/reversões de depreciação</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '4'">
                                            <v-edit-dialog :return-value.sync="VALUES.T1A.gastosreversoesdepreciacao">
                                                {{ numberWithSpaces(VALUES.T1A.gastosreversoesdepreciacao) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1A.gastosreversoesdepreciacao" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T1B.gastosreversoesdepreciacao">
                                                {{ numberWithSpaces(VALUES.T1B.gastosreversoesdepreciacao) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1B.gastosreversoesdepreciacao" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(getDiffT1('gastosreversoesdepreciacao').replace('-',''))}}</td>
                                        <td v-if="editedItem.anos2">{{getPercentT1('gastosreversoesdepreciacao')}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Gastos/reversões de amortização</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '4'">
                                            <v-edit-dialog :return-value.sync="VALUES.T1A.gastosreversoesdeamortizacao">
                                                {{ numberWithSpaces(VALUES.T1A.gastosreversoesdeamortizacao) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1A.gastosreversoesdeamortizacao" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T1B.gastosreversoesdeamortizacao">
                                                {{ numberWithSpaces(VALUES.T1B.gastosreversoesdeamortizacao) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1B.gastosreversoesdeamortizacao" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(getDiffT1('gastosreversoesdeamortizacao').replace('-',''))}}</td>
                                        <td v-if="editedItem.anos2">{{getPercentT1('gastosreversoesdeamortizacao')}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-right">Resultado operacional (antes de gastos de financiamento e impostos)</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '4'"><b>{{numberWithSpaces(T1T2A)}}</b></td>
                                        <td v-if="editedItem.anos2"><b>{{numberWithSpaces(T1T2B)}}</b></td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(getDiffTotal('2'))}}</td>
                                        <td v-if="editedItem.anos2">{{(getPercentTotal('2'))}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Gasto líquido de financiamento</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '4'">
                                            <v-edit-dialog :return-value.sync="VALUES.T1A.gastoliquidofinanciamento">
                                                {{ numberWithSpaces(VALUES.T1A.gastoliquidofinanciamento) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1A.gastoliquidofinanciamento" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T1B.gastoliquidofinanciamento">
                                                {{ numberWithSpaces(VALUES.T1B.gastoliquidofinanciamento) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1B.gastoliquidofinanciamento" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(getDiffT1('gastoliquidofinanciamento').replace('-',''))}}</td>
                                        <td v-if="editedItem.anos2">{{getPercentT1('gastoliquidofinanciamento')}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-right">Resultado antes de impostos</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '4'"><b>{{numberWithSpaces(T1T3A)}}</b></td>
                                        <td v-if="editedItem.anos2"><b>{{numberWithSpaces(T1T3B)}}</b></td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(getDiffTotal('3'))}}</td>
                                        <td v-if="editedItem.anos2">{{(getPercentTotal('3'))}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Imposto sobre o rendimento do período</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '4'">
                                            <v-edit-dialog :return-value.sync="VALUES.T1A.impostosrp">
                                                {{ numberWithSpaces(VALUES.T1A.impostosrp) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field @change="changeP21"  type="number" min="0" step=".1" color="#969462" v-model="VALUES.T1A.impostosrp" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T1B.impostosrp">
                                                {{ numberWithSpaces(VALUES.T1B.impostosrp) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-fieldtype="number" min="0" step=".1" color="#969462" v-model="VALUES.T1B.impostosrp" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(getDiffT1('impostosrp').replace('-',''))}}</td>
                                        <td v-if="editedItem.anos2">{{getPercentT1('impostosrp')}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-right">Resultado líquido do período</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '4'"><b>{{numberWithSpaces(T1T4A)}}</b></td>
                                        <td v-if="editedItem.anos2"><b>{{numberWithSpaces(T1T4B)}}</b></td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(getDiffTotal('4'))}}</td>
                                        <td v-if="editedItem.anos2">{{(getPercentTotal('4'))}}</td>
                                    </tr>
                                </table>
                            </div>
                        </v-flex>

                        <v-flex xs5 sm5 md5 pb-5>
                            <div v-if="(VALUES.CH1.MESES.length + VALUES.CH1.EMV.length + VALUES.CH1.CMVMC.length + VALUES.CH1.MB.length) > 0" id="CH1">
                                <Chart1 :MESES="VALUES.CH1.MESES" :EMV="VALUES.CH1.EMV" :CMVMC="VALUES.CH1.CMVMC" :MB="VALUES.CH1.MB" />
                            </div>
                        </v-flex>

                        <v-flex xs5 sm5 md5 pl-5 pb-5>
                            <div v-if="(VALUES.CH2.MESES.length + VALUES.CH2.FSEM.length + VALUES.CH2.OG.length + VALUES.CH2.MB.length) > 0" id="CH2">
                                <Chart2 :MESES="VALUES.CH2.MESES" :FSEM="VALUES.CH2.FSEM" :OG="VALUES.CH2.OG" :MB="VALUES.CH2.MB" />
                            </div>
                        </v-flex>

                        <v-flex xs5 sm5 md5 pb-5>
                            <div v-if="(VALUES.CH3.MESES.length + VALUES.CH3.FSEM.length + VALUES.CH3.OG.length + VALUES.CH3.FSE.length) > 0" id="CH3">
                                <Chart3 :MESES="VALUES.CH3.MESES" :FSEM="VALUES.CH3.FSEM" :FSE="VALUES.CH3.FSE" :OG="VALUES.CH3.OG" />
                            </div>
                        </v-flex>

                        <v-flex xs5 sm5 md5 pl-5 pb-5>
                            <div v-if="(VALUES.CH4.MESES.length + VALUES.CH4.C6869.length + VALUES.CH4.C68.length + VALUES.CH4.C69.length) > 0" id="CH4">
                                <Chart4 :MESES="VALUES.CH4.MESES" :C6869="VALUES.CH4.C6869" :C68="VALUES.CH4.C68" :C69="VALUES.CH4.C69" />
                            </div>
                        </v-flex>

                        <v-flex xs5 sm5 md5 pb-5>
                            <div v-if="(VALUES.CH5.ORDEM.length + VALUES.CH5.G.length) > 0" id="CH5">
                                <Chart5 :ORDEM="VALUES.CH5.ORDEM" :G="VALUES.CH5.G" />
                            </div>
                        </v-flex>

                        <v-flex xs5 sm5 md5 pl-5 pb-5>
                            <div v-if="(VALUES.CH5.ORDEM.length + VALUES.CH5.G.length) > 0" id="T2">
                                <table width="100%" style="text-align: right;">
                                    <tr>
                                        <th class="table-left">Ranking decrescente dos gastos</th>
                                        <th>Valor</th>
                                    </tr>
                                    <tr v-for="(item, i) in VALUES.CH5.TABELA" :key="i">
                                        <td class="table-left">{{item.ordem}} - {{item.conta}}</td>
                                        <td>{{ numberWithSpaces(parseFloat(item.saldo.replace(',','.')).toFixed(2)) }} €</td>
                                    </tr>
                                    <tr>
                                        <th class="table-left">Valor total dos gastos</th>
                                        <th>{{ numberWithSpaces(getTotalByProperty(VALUES.CH5.TABELA, 'saldo')) }}</th>
                                    </tr>
                                </table>
                            </div>
                        </v-flex>

                        <v-flex xs10 sm10 md10 pb-5>
                            <div id="T3">
                                <table width="100%" style="text-align: right;">
                                    <tr>
                                        <th width="30%">Rubricas</th>
                                        <th width="20%" colspan="2">Períodos</th>
                                        <th width="30%">Rubricas</th>
                                        <th width="20%" colspan="2">Períodos</th>
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <th :colspan="editedItem.anos2 ? '1' : '2'" width="10%">{{Number(ano)}}</th>
                                        <th v-if="editedItem.anos2" width="10%">{{(Number(ano) - 1)}}</th>
                                        <th></th>
                                        <th :colspan="editedItem.anos2 ? '1' : '2'" width="10%">{{Number(ano)}}</th>
                                        <th v-if="editedItem.anos2" width="10%">{{(Number(ano) - 1)}}</th>
                                    </tr>
                                    <tr>
                                        <td colspan="3" class="table-left bold-up" style="text-align: center !important;">Ativo</td>
                                        <td colspan="3" class="table-left bold-up" style="text-align: center !important;">Capital próprio e passivo</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3" class="table-left bold-up">Ativo não corrente</td>
                                        <td colspan="3" class="table-left bold-up">Capital próprio</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Ativos fixos tangíveis</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="AtivosTangiveisA">
                                                {{ numberWithSpaces(AtivosTangiveisA) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="AtivosTangiveisA" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="AtivosTangiveisB">
                                                {{ numberWithSpaces(AtivosTangiveisB) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="AtivosTangiveisB" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td class="table-left">Capital realizado</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="VALUES.T3A.capitalrealizado">
                                                {{ numberWithSpaces(VALUES.T3A.capitalrealizado) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3A.capitalrealizado" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T3B.capitalrealizado">
                                                {{ numberWithSpaces(VALUES.T3B.capitalrealizado) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3B.capitalrealizado" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Ativos intangíveis</td>
                                         <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="AtivosIntangiveisA">
                                                {{ numberWithSpaces(AtivosIntangiveisA) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="AtivosIntangiveisA" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="AtivosIntangiveisB">
                                                {{ numberWithSpaces(AtivosIntangiveisB) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="AtivosIntangiveisB" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td class="table-left">Outros instrumentos de capital próprio</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="VALUES.T3A.outrosintrumentoscapitalproprio">
                                                {{ numberWithSpaces(VALUES.T3A.outrosintrumentoscapitalproprio) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3A.outrosintrumentoscapitalproprio" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T3B.outrosintrumentoscapitalproprio">
                                                {{ numberWithSpaces(VALUES.T3B.outrosintrumentoscapitalproprio) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3B.outrosintrumentoscapitalproprio" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Investimentos financeiros</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="VALUES.T3A.investimentosfinanceiros">
                                                {{ numberWithSpaces(VALUES.T3A.investimentosfinanceiros) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3A.investimentosfinanceiros" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T3B.investimentosfinanceiros">
                                                {{ numberWithSpaces(VALUES.T3B.investimentosfinanceiros) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3B.investimentosfinanceiros" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td class="table-left">Reservas</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="VALUES.T3A.reservas">
                                                {{ numberWithSpaces(VALUES.T3A.reservas) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3A.reservas" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T3B.reservas">
                                                {{ numberWithSpaces(VALUES.T3B.reservas) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3B.reservas" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Créditos e outros ativos não correntes</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="VALUES.T3A.creditosoutrosativosnaocorrentes">
                                                {{ numberWithSpaces(VALUES.T3A.creditosoutrosativosnaocorrentes) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3A.creditosoutrosativosnaocorrentes" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T3B.creditosoutrosativosnaocorrentes">
                                                {{ numberWithSpaces(VALUES.T3B.reservas) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3B.creditosoutrosativosnaocorrentes" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td class="table-left">Resultados transitados</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="VALUES.T3A.resultadostransitados">
                                                {{ numberWithSpaces(VALUES.T3A.resultadostransitados) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3A.resultadostransitados" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T3B.resultadostransitados">
                                                {{ numberWithSpaces(VALUES.T3B.resultadostransitados) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3B.resultadostransitados" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="table-right">Total do ativo não corrente</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">{{numberWithSpaces(T3T1A)}}</td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(T3T1B)}}</td>
                                        <td class="table-left">Outras variações de capital próprio</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="VALUES.T3A.outrasvariacoescapitalproprio">
                                                {{ numberWithSpaces(VALUES.T3A.outrasvariacoescapitalproprio) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3A.outrasvariacoescapitalproprio" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T3B.outrasvariacoescapitalproprio">
                                                {{ numberWithSpaces(VALUES.T3B.outrasvariacoescapitalproprio) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3B.outrasvariacoescapitalproprio" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">{{numberWithSpaces(T3T2A)}}</td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(T3T2B)}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3" class="table-left bold-up">Ativo corrente</td>
                                        <td class="table-left">Resultado líquido do período</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">{{numberWithSpaces(T1T4A)}}</td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(T1T4B)}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Inventrários</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="VALUES.T3A.inventarios">
                                                {{ numberWithSpaces(VALUES.T3A.inventarios) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3A.inventarios" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T3B.inventarios">
                                                {{ numberWithSpaces(VALUES.T3A.inventarios) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3A.inventarios" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td class="table-right">Total do capital próprio</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">{{numberWithSpaces(T3T3A)}}</td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(T3T3B)}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Clientes</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="VALUES.T3A.clientes">
                                                {{ numberWithSpaces(VALUES.T3A.clientes) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3A.clientes" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T3B.clientes">
                                                {{ numberWithSpaces(VALUES.T3B.clientes) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3B.clientes" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td class="table-left"><b>Passivo</b></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Estado e outros entes públicos</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="VALUES.T3A.estadooutrosentespublicosativo">
                                                {{ numberWithSpaces(VALUES.T3A.estadooutrosentespublicosativo) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3A.estadooutrosentespublicosativo" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T3B.estadooutrosentespublicosativo">
                                                {{ numberWithSpaces(VALUES.T3B.estadooutrosentespublicosativo) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3B.estadooutrosentespublicosativo" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td class="table-left"><b>Passivo não corrente</b></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Diferimentos</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="VALUES.T3A.diferimentosativo">
                                                {{ numberWithSpaces(VALUES.T3A.diferimentosativo) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3A.diferimentosativo" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T3B.diferimentosativo">
                                                {{ numberWithSpaces(VALUES.T3B.diferimentosativo) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3B.diferimentosativo" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td class="table-left">Provisões</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="VALUES.T3A.provisoes">
                                                {{ numberWithSpaces(VALUES.T3A.provisoes) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3A.provisoes" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T3B.provisoes">
                                                {{ numberWithSpaces(VALUES.T3B.provisoes) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3B.provisoes" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Outros ativos correntes</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="VALUES.T3A.outrosativoscorrentes">
                                                {{ numberWithSpaces(VALUES.T3A.outrosativoscorrentes) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3A.outrosativoscorrentes" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T3B.outrosativoscorrentes">
                                                {{ numberWithSpaces(VALUES.T3B.outrosativoscorrentes) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3B.outrosativoscorrentes" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td class="table-left">Financiamentos obtidos</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="VALUES.T3A.financiamentosobtidos">
                                                {{ numberWithSpaces(VALUES.T3A.financiamentosobtidos) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3A.financiamentosobtidos" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T3B.financiamentosobtidos">
                                                {{ numberWithSpaces(VALUES.T3B.financiamentosobtidos) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3B.financiamentosobtidos" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Caixa e depósitos bancários</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="VALUES.T3A.caixaedepositosbancarios">
                                                {{ numberWithSpaces(VALUES.T3A.caixaedepositosbancarios) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3A.caixaedepositosbancarios" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T3B.caixaedepositosbancarios">
                                                {{ numberWithSpaces(VALUES.T3B.caixaedepositosbancarios) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3B.caixaedepositosbancarios" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td class="table-left">Outras contas a pagar</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="VALUES.T3A.outrascontaspagar">
                                                {{ numberWithSpaces(VALUES.T3A.outrascontaspagar) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3A.outrascontaspagar" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T3B.outrascontaspagar">
                                                {{ numberWithSpaces(VALUES.T3B.outrascontaspagar) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3B.outrascontaspagar" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="table-right">Total do ativo corrente</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">{{numberWithSpaces(T3T4A)}}</td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(T3T4B)}}</td>
                                        <td class="table-right">Total do passivo não corrente</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">{{numberWithSpaces(T3T5A)}}</td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(T3T5B)}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3"></td>
                                        <td class="table-left"><b>Passivo corrente</b></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td colspan="3"></td>
                                        <td class="table-left">Fornecedores</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="VALUES.T3A.fornecedores">
                                                {{ numberWithSpaces(VALUES.T3A.fornecedores) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3A.fornecedores" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T3B.fornecedores">
                                                {{ numberWithSpaces(VALUES.T3B.fornecedores) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3B.fornecedores" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3"></td>
                                        <td class="table-left">Estado e outros entes públicos</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="VALUES.T3A.estadooutrosentespublicospassivo">
                                                {{ numberWithSpaces(VALUES.T3A.estadooutrosentespublicospassivo) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3A.estadooutrosentespublicospassivo" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T3B.estadooutrosentespublicospassivo">
                                                {{ numberWithSpaces(VALUES.T3B.estadooutrosentespublicospassivo) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3B.estadooutrosentespublicospassivo" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3"></td>
                                        <td class="table-left">Diferimentos</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="VALUES.T3A.diferimentospassivo">
                                                {{ numberWithSpaces(VALUES.T3A.diferimentospassivo) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3A.diferimentospassivo" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T3B.diferimentospassivo">
                                                {{ numberWithSpaces(VALUES.T3B.diferimentospassivo) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3B.diferimentospassivo" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3"></td>
                                        <td class="table-left">Outros passivos correntes</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">
                                            <v-edit-dialog :return-value.sync="VALUES.T3A.outrospassivoscorrentes">
                                                {{ numberWithSpaces(VALUES.T3A.outrospassivoscorrentes) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3A.outrospassivoscorrentes" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td v-if="editedItem.anos2">
                                            <v-edit-dialog :return-value.sync="VALUES.T3B.outrospassivoscorrentes">
                                                {{ numberWithSpaces(VALUES.T3B.outrospassivoscorrentes) || '-' }}
                                                <template v-slot:input>
                                                    <v-text-field type="number" min="0" step=".1" color="#969462" v-model="VALUES.T3B.outrospassivoscorrentes" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3"></td>
                                        <td class="table-right">Total do passivo corrente</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">{{numberWithSpaces(T3T6A)}}</td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(T3T6B)}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3"></td>
                                        <td class="table-right">Total do passivo</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">{{numberWithSpaces(T3T7A)}}</td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(T3T7B)}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-right">Total do ativo</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">{{numberWithSpaces(T3T8A)}}</td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(T3T8B)}}</td>
                                        <td class="table-right">Total do capital próprio e do passivo</td>
                                        <td :colspan="editedItem.anos2 ? '1' : '2'">{{numberWithSpaces(T3T9A)}}</td>
                                        <td v-if="editedItem.anos2">{{numberWithSpaces(T3T9B)}}</td>
                                    </tr>
                                </table>
                            </div>
                        </v-flex>

                        <v-flex xs5 sm5 md5 pb-5>
                            <div v-if="VALUES.T3A.displayCH6" id="CH6">
                                <Chart6 :ANC="T3T1A" :AC="T3T4A" />
                            </div>
                        </v-flex>

                        <v-flex xs5 sm5 md5 pl-5 pb-5>
                            <div v-if="VALUES.T3A.displayCH7" id="CH7">
                                <Chart7 :CP="T3T3A" :PNC="T3T5A" :PC="T3T6A" />
                            </div>
                        </v-flex>

                        <v-flex xs4 sm4 md4 pb-5>
                            <div id="T4">
                                <table width="100%" style="text-align: right;">
                                    <tr>
                                        <th width="50%" class="table-left bold-up">Descrição</th>
                                        <th width="50%" class="bold-up">Ano</th>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="bold-up table-left">Indicadores de rentabilidade</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Margem bruta sobre as vendas (1)</td>
                                        <td>
                                            <v-progress-linear color="rgb(98, 150, 103, 0.5)" height="20" :value="T4T1">{{T4T1}}%</v-progress-linear>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Rendibilidade das vendas (2)</td>
                                        <td>
                                            <v-progress-linear color="rgb(98, 150, 103, 0.5)" height="20" :value="T4T2">{{T4T2}}%</v-progress-linear>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Rendibilidade dos capitais próprios (3)</td>
                                        <td>
                                            <v-progress-linear color="rgb(98, 150, 103, 0.5)" height="20" :value="T4T3">{{T4T3}}%</v-progress-linear>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Rendibilidade do ativo (4)</td>
                                        <td>
                                            <v-progress-linear color="rgb(98, 150, 103, 0.5)" height="20" :value="T4T4">{{T4T4}}%</v-progress-linear>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="bold-up table-left">Indicadores de endividamento</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Autonomia financeira (5)</td>
                                        <td>
                                            <v-progress-linear :color="parseFloat(T4T5)>=50 ? 'green' : 'red'" height="20" :value="T4T5">{{T4T5}}%</v-progress-linear>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Peso do passivo (6)</td>
                                        <td>
                                            <v-progress-linear :color="parseFloat(T4T6)>=50 ? 'red' : 'green'" height="20" :value="T4T6">{{T4T6}}%</v-progress-linear>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="bold-up table-left">Indicadores de atividade</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Prazo médio de recebimento (7)</td>
                                        <td>{{T4T7}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Prazo médio de pagamento (8)</td>
                                        <td>{{T4T8}}</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Rácio de Rotação do Ativo (9)</td>
                                        <td>{{T4T9}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="bold-up table-left">Indicadores de liquidez</td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Indicador de liquidez geral (10)</td>
                                        <td class="linha-indicadores"><span v-bind:class="[parseFloat(T4T10.replace('.', ',')) >= 2 ? 'bola bola-verde' : (parseFloat(T4T10.replace('.', ','))>=1 && parseFloat(T4T10.replace('.', ',')) <2 ? 'bola bola-laranja' : 'bola bola-vermelha')]"></span><span>{{T4T10}}</span></td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Indicador de liquidez reduzida (11)</td>
                                        <td class="linha-indicadores"><span v-bind:class="[parseFloat(T4T11.replace('.', ',')) >= 2 ? 'bola bola-verde' : (parseFloat(T4T11.replace('.', ','))>=1 && parseFloat(T4T11.replace('.', ',')) <2 ? 'bola bola-laranja' : 'bola bola-vermelha')]"></span><span>{{T4T11}}</span></td>
                                    </tr>
                                    <tr>
                                        <td class="table-left">Indicador de liquidez imediata (12)</td>
                                        <td class="linha-indicadores"><span v-bind:class="[parseFloat(T4T12.replace('.', ',')) >= 2 ? 'bola bola-verde' : (parseFloat(T4T12.replace('.', ','))>=1 && parseFloat(T4T12.replace('.', ',')) <2 ? 'bola bola-laranja' : 'bola bola-vermelha')]"></span><span>{{T4T12}}</span></td>
                                    </tr>
                                </table>
                            </div>
                        </v-flex>

                        <v-flex xs6 sm6 md6 pl-5 pb-5>
                            <div id="T5">
                                <table width="100%" style="text-align: center;">
                                    <tr>
                                        <th class="bold-up">Nº</th>
                                        <th class="bold-up">Forma de Cálculo</th>
                                        <th class="bold-up">Significado Económico</th>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>(Vendas - Custos Directos) / Vendas</td>
                                        <td>Percentagem de lucro bruto (depois de retirados os custos directos) calculado sobre o preço de venda</td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td>Resultado líquido / Vendas</td>
                                        <td>Percentagem de lucro líquido (depois de retirados todos os custos) calculada sobre o preço de venda</td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td>Resultado líquido / Capital próprio</td>
                                        <td>Estimativa da taxa de rendibilidade obtida pelos sócios ou accionistas</td>
                                    </tr>
                                    <tr>
                                        <td>4</td>
                                        <td>(Resultado Antes de Impostos - Juros)/Ativo</td>
                                        <td>Estimativa da taxa de rendibilidade méida obtida pelos sócios ou accionistas e pelos financeiros (banca)</td>
                                    </tr>
                                    <tr>
                                        <td>5</td>
                                        <td>Capital Próprio / Ativo</td>
                                        <td>Parte dos bens e direitos da empresa que é financiada por fundos dos sócios ou accionistas</td>
                                    </tr>
                                    <tr>
                                        <td>6</td>
                                        <td>Passivo / Ativo</td>
                                        <td>Parte dos bens e direitos da empresa que é financidada por fundos alheios (banca, fornecedores, estado)</td>
                                    </tr>
                                    <tr>
                                        <td>7</td>
                                        <td>(Clientes / Vendas) * 365</td>
                                        <td>Estimativa do número médio de dias que os clientes demoram a pagar</td>
                                    </tr>
                                    <tr>
                                        <td>8</td>
                                        <td>(Fornecedores / Compras de bens e serviços) * 365</td>
                                        <td>Estimativa do número médio de dias que se demora a pagar aos fornecedores</td>
                                    </tr>
                                    <tr>
                                        <td>9</td>
                                        <td>Vendas / Ativo Total</td>
                                        <td>Eficiência no uso dos ativos da empresa</td>
                                    </tr>
                                    <tr>
                                        <td>10</td>
                                        <td>Ativo Corrente / Passivo Corrente</td>
                                        <td>Parte do ativo corrente sobre o passivo de curto prazo</td>
                                    </tr>
                                    <tr>
                                        <td>11</td>
                                        <td>(Ativo Corrente - Stocks) / Passivo Corrente</td>
                                        <td>Parte do ativo corrente depois de retirados os stocks calculada sobre o passivo de curto prazo</td>
                                    </tr>
                                    <tr>
                                        <td>12</td>
                                        <td>Ativo disponível / Passivo Corrente</td>
                                        <td>Parte do ativo disponível calculada sobre o passivo de curto prazo</td>
                                    </tr>
                                </table>
                            </div>
                        </v-flex>

                    </v-layout>
                </v-card>

            </v-card>
        </v-dialog>

        <v-data-table :headers="headers" :items="DATA" :search="search" :loading="loading" item-key="id" :disable-initial-sort="true" :rows-per-page-items='[10,25,50,{"text":"Todos","value":-1}]' rows-per-page-text="Itens por página:">
            <template slot="items" slot-scope="props">
                <td @click="editItem(props.item, true)" class="textLeft">{{ props.item.id_utilizador }}</td>
                <td @click="editItem(props.item, true)" class="textLeft">{{ props.item.nome }}</td>
                <td @click="editItem(props.item, true)" class="textLeft">{{ props.item.codigo }}</td>
                <td @click="editItem(props.item, true)" class="textLeft">{{ props.item.email }}</td>
                <td @click="editItem(props.item, true)" v-bind:class="[props.item.termos == 1  ? 'textLeft aceite' : 'textLeft naceite']">{{ props.item.termos == 1 ? 'Aceite' : 'Não aceite' }}</td>
                <td @click="editItem(props.item, true)" class="textRight">{{ props.item.nif }}</td>
                <td class="px-0 textTable textCenter">
                    <v-btn icon class="mx-0" @click="getReport(props.item)">
                        <v-icon color="amber">receipt</v-icon>
                    </v-btn>
                    <v-btn icon class="mx-0" @click="editItem(props.item, true)">
                        <v-icon color="light-green darken-1">edit</v-icon>
                    </v-btn>
                    <v-btn icon class="mx-0" @click="editItem(props.item, false)">
                        <v-icon color="red lighten-1">delete</v-icon>
                    </v-btn>
                </td>
            </template>

            <template class="alertTable" slot="no-data">
                <v-alert :value="true" icon="warning">
                    De momento não há nada a apresentar! :(
                </v-alert>
            </template>
        </v-data-table>

    </div>
</v-flex>
</template>

<script>
import {
    mapState,
    mapGetters,
    mapActions
} from "vuex";

import axios from 'axios';
import qs from 'qs';
import convert from "xml-js";

const cName = {
    upper: "Cliente",
    lower: "o cliente!"
};

const margin = 10;

const P1 = {
    volnegocios: 0,
    margembruta: 0
};

const T1 = {
    vendasservicosprestados: 0,
    subsidiosaexploracao: 0,
    variacaoinventariosprod: 0,
    trabalhospropriaentidade: 0,
    cmvcmc: 0,
    fse: 0,
    gastoscompessoal: 0,
    gastosreversoesdepreciacao: 0,
    gastosreversoesdeamortizacao: 0,
    imparidade: 0,
    provisoes: 0,
    outrosrendimentosganhos: 0,
    outrosgastosperdas: 0,
    saldoconta79: 0,
    saldoconta69: 0,
    gastoliquidofinanciamento: 0,
    impostosrp: 0
};

const T3 = {
    displayCH6: false,
    displayCH7: false,
    saldo11: 0,
    saldo12: 0,
    saldo13: 0,
    saldo14ativo: 0,
    clientes: 0,
    fornecedores: 0,
    saldo23passivo: 0,
    estadooutrosentespublicospassivo: 0,
    financiamentosobtidos: 0,
    saldo27passivo: 0,
    inventarios: 0,
    investimentosfinanceiros: 0,
    saldo43: 0,
    saldo44: 0,
    capitalrealizado: 0,
    reservas: 0,
    resultadostransitados: 0,
    diferimentosativo: 0,
    ativostangiveis: 0,
    ativosintangiveis: 0,
    outrosativoscorrentes: 0,
    outrospassivoscorrentes: 0,
    caixaedepositosbancarios: 0,
    outrasvariacoescapitalproprio: 0,
    outrosintrumentoscapitalproprio: 0,
    estadooutrosentespublicosativo: 0,
    diferimentospassivo: 0,
    outrascontaspagar: 0,
    creditosoutrosativosnaocorrentes: 0,
    provisoes: 0,
};

const CH1 = {
    MESES: [],
    EMV: [],
    CMVMC: [],
    MB: [],
}

const CH2 = {
    MESES: [],
    MB: [],
    FSEM: [],
    OG: []
}

const CH3 = {
    MESES: [],
    FSEM: [],
    FSE: [],
    OG: []
}

const CH4 = {
    MESES: [],
    C68: [],
    C69: [],
    C6869: []
}

const CH5 = {
    ORDEM: [],
    G: [],
    TABELA: []
}

export default {
    data: () => ({
        logo: require('@/assets/logo.jpg'),
        base64Img: null,
        email: false,
        E: {},
        loader: false,
        REPORT: [],
        STRINGS: [],
        dialog: false,
        form: false,
        table: 'utilizadores',
        name: 'cliente',
        search: "",
        modal: false,
        deleteM: false,
        loading: true,
        searchP: '',
        ano: '',
        mes: '',
        show: false,
        cpwd: null,
        meses: [{
                mes: 1,
                nome: 'Janeiro'
            },
            {
                mes: 2,
                nome: 'Fevereiro'
            },
            {
                mes: 3,
                nome: 'Março'
            },
            {
                mes: 4,
                nome: 'Abril'
            },
            {
                mes: 5,
                nome: ' Maio'
            },
            {
                mes: 6,
                nome: 'Junho'
            },
            {
                mes: 7,
                nome: 'Julho'
            },
            {
                mes: 8,
                nome: 'Agosto'
            },
            {
                mes: 9,
                nome: 'Setembro'
            },
            {
                mes: 10,
                nome: 'Outubro'
            },
            {
                mes: 11,
                nome: 'Novembro'
            },
            {
                mes: 12,
                nome: 'Dezembro'
            }
        ],
        headers: [{
                text: "#",
                align: "left",
                sortable: true,
                value: "id_utilizador"
            },
            {
                text: "Nome",
                align: "left",
                sortable: true,
                value: "nome"
            },
            {
                text: "Código",
                align: "left",
                sortable: true,
                value: "codigo"
            },
            {
                text: "Email",
                align: "left",
                sortable: true,
                value: "email"
            },
            {
                text: "Termos",
                align: "left",
                sortable: true,
                value: "termos"
            },
            {
                text: "NIF",
                align: "right",
                sortable: true,
                value: "nif"
            },
            {
                text: "Ações",
                value: "id",
                sortable: false,
                align: "center"
            }
        ],
        path: null,
        DATA: [],
        editedIndex: -1,
        editedItem: {
            id_utilizador: '',
            nome: "",
            email: "",
            codigo: "",
            urlwebsite: "",
            nif: "",
            ano: '2018',
            pastas: '',
            anos2: 0,
            password: '',
            telefone: ''
        },
        defaultItem: {
            id_utilizador: '',
            nome: "",
            email: "",
            codigo: "",
            urlwebsite: "",
            nif: "",
            ano: '2018',
            pastas: '',
            anos2: 0,
            password: '',
            telefone: ''
        },
        messages: {
            add: {
                success: cName.upper + " criado com sucesso!",
                error: "Ocorreu um erro ao criar " + cName.lower
            },
            update: {
                success: cName.upper + " alterado com sucesso!",
                error: "Ocorreu um erro ao alterar " + cName.lower
            },
            delete: {
                success: cName.upper + " eliminado com sucesso!",
                error: "Ocorreu um erro ao apagar " + cName.lower
            },
            default: {
                sucesso: "Sucesso",
                error: "Ocorreu um erro!"
            }
        },
        defaultRules: null,
        VALUES: {
            P1: Object.assign({}, P1),
            T1A: Object.assign({}, T1),
            T1B: Object.assign({}, T1),
            CH1: Object.assign({}, CH1),
            CH2: Object.assign({}, CH2),
            CH3: Object.assign({}, CH3),
            CH4: Object.assign({}, CH4),
            CH5: Object.assign({}, CH5),
            T3A: Object.assign({}, T3),
            T3B: Object.assign({}, T3),
        },
        defaultValues: {
            P1: Object.assign({}, P1),
            T1A: Object.assign({}, T1),
            T1B: Object.assign({}, T1),
            CH1: Object.assign({}, CH1),
            CH2: Object.assign({}, CH2),
            CH3: Object.assign({}, CH3),
            CH4: Object.assign({}, CH4),
            CH5: Object.assign({}, CH5),
            T3A: Object.assign({}, T3),
            T3B: Object.assign({}, T3),
        },
        pwdRules: null,
    }),

    computed: {
        ...mapGetters({
            getAll: 'utilizadores/getClientes',
            getEscritorios: 'escritorios/getAll',
            getLinks: 'session/getLinks'
        }),
        formTitle() {
            return this.editedIndex === -1 ? "Novo " + this.name : "Editar " + this.name;
        },
        cmvcmcA(){
            var total = parseFloat(this.VALUES.T1A.cmvcmc) - parseFloat(this.VALUES.T3A.inventarios);

            return parseFloat(total).toFixed(2);
        },
        cmvcmcB() {
            var total = parseFloat(this.VALUES.T1B.cmvcmc) - parseFloat(this.VALUES.T3B.inventarios);

            return parseFloat(total).toFixed(2);
        },
        T1T1A() {
            var val = this.VALUES.T1A;
            var total = parseFloat(String(val.vendasservicosprestados).replace('-','')) + parseFloat(String(val.subsidiosaexploracao).replace('-','')) + parseFloat(String(val.variacaoinventariosprod).replace('-','')) + parseFloat(String(val.trabalhospropriaentidade).replace('-','')) - parseFloat(String(val.cmvcmc).replace('-','')) - parseFloat(String(val.fse).replace('-','')) - parseFloat(String(val.gastoscompessoal).replace('-','')) - parseFloat(String(val.imparidade).replace('-','')) + parseFloat(String(val.provisoes).replace('-','')) + parseFloat(String(val.outrosrendimentosganhos).replace('-','')) - parseFloat(String(val.outrosgastosperdas).replace('-',''));

            return parseFloat(total).toFixed(2);
        },
        T1T2A() {
            var total = this.T1T1A - parseFloat(this.VALUES.T1A.gastosreversoesdepreciacao);

            return parseFloat(total).toFixed(2);
        },
        T1T3A() {
            var total = this.T1T2A - parseFloat(this.VALUES.T1A.gastoliquidofinanciamento);

            return parseFloat(total).toFixed(2);
        },
        T1T4A() {
            var total = this.T1T3A - parseFloat(this.VALUES.T1A.impostosrp);

            return parseFloat(total).toFixed(2);
        },
        T1T1B() {
            var val = this.VALUES.T1B;
            var total = parseFloat(String(val.vendasservicosprestados).replace('-','')) + parseFloat(String(val.subsidiosaexploracao).replace('-','')) + parseFloat(String(val.variacaoinventariosprod).replace('-','')) + parseFloat(String(val.trabalhospropriaentidade).replace('-','')) - parseFloat(String(val.cmvcmc).replace('-','')) - parseFloat(String(val.fse).replace('-','')) - parseFloat(String(val.gastoscompessoal).replace('-','')) - parseFloat(String(val.imparidade).replace('-','')) + parseFloat(String(val.provisoes).replace('-','')) + parseFloat(String(val.outrosrendimentosganhos).replace('-','')) - parseFloat(String(val.outrosgastosperdas).replace('-',''));

            return parseFloat(total).toFixed(2);
        },
        T1T2B() {
            var total = this.T1T1B - parseFloat(this.VALUES.T1B.gastosreversoesdepreciacao);

            return parseFloat(total).toFixed(2);
        },
        T1T3B() {
            var total = this.T1T2B - parseFloat(this.VALUES.T1B.gastoliquidofinanciamento);

            return parseFloat(total).toFixed(2);
        },
        T1T4B() {
            var total = this.T1T3B - parseFloat(this.VALUES.T1B.impostosrp);

            return parseFloat(total).toFixed(2);
        },
        T3T1A() {
            var val = this.VALUES.T3A;
            var total = parseFloat(val.ativostangiveis) + parseFloat(val.ativosintangiveis) + parseFloat(val.investimentosfinanceiros) + parseFloat(val.creditosoutrosativosnaocorrentes);

            return parseFloat(total).toFixed(2);
        },
        T3T1B() {
            var val = this.VALUES.T3B;
            var total = parseFloat(val.ativostangiveis) + parseFloat(val.ativosintangiveis) + parseFloat(val.investimentosfinanceiros) + parseFloat(val.creditosoutrosativosnaocorrentes);

            return parseFloat(total).toFixed(2);
        },
        T3T2A() {
            var val = this.VALUES.T3A;
            var total = parseFloat(val.capitalrealizado) + parseFloat(val.outrosintrumentoscapitalproprio) + parseFloat(val.reservas) + parseFloat(val.resultadostransitados) + parseFloat(val.outrasvariacoescapitalproprio);

            return parseFloat(total).toFixed(2);
        },
        T3T2B() {
            var val = this.VALUES.T3B;
            var total = parseFloat(val.capitalrealizado) + parseFloat(val.outrosintrumentoscapitalproprio) + parseFloat(val.reservas) + parseFloat(val.resultadostransitados) + parseFloat(val.outrasvariacoescapitalproprio);

            return parseFloat(total).toFixed(2);
        },
        T3T3A() {
            var total = this.T3T2A + this.T1T4A;

            return parseFloat(total).toFixed(2);
        },
        T3T3B() {
            var total = this.T3T2B + this.T1T4B;

            return parseFloat(total).toFixed(2);
        },
        T3T4A() {
            var val = this.VALUES.T3A;
            var total = parseFloat(val.inventarios) + parseFloat(val.clientes) + parseFloat(val.estadooutrosentespublicosativo) + parseFloat(val.diferimentosativo) + parseFloat(val.outrosativoscorrentes) + parseFloat(val.caixaedepositosbancarios);

            return parseFloat(total).toFixed(2);
        },
        T3T4B() {
            var val = this.VALUES.T3B;
            var total = parseFloat(val.inventarios) + parseFloat(val.clientes) + parseFloat(val.estadooutrosentespublicosativo) + parseFloat(val.diferimentosativo) + parseFloat(val.outrosativoscorrentes) + parseFloat(val.caixaedepositosbancarios);

            return parseFloat(total).toFixed(2);
        },
        T3T5A() {
            var val = this.VALUES.T3A;
            var total = parseFloat(val.provisoes) + parseFloat(val.financiamentosobtidos) + parseFloat(val.outrascontaspagar);
            return parseFloat(total).toFixed(2);
        },
        T3T5B() {
            var val = this.VALUES.T3B;
            var total = parseFloat(val.provisoes) + parseFloat(val.financiamentosobtidos) + parseFloat(val.outrascontaspagar);

            return parseFloat(total).toFixed(2);
        },
        T3T6A() {
            var val = this.VALUES.T3A;
            var total = parseFloat(val.fornecedores) + parseFloat(val.estadooutrosentespublicospassivo) + parseFloat(val.diferimentospassivo) + parseFloat(val.outrospassivoscorrentes);

            return parseFloat(total).toFixed(2);
        },
        T3T6B() {
            var val = this.VALUES.T3B;
            var total = parseFloat(val.fornecedores) + parseFloat(val.estadooutrosentespublicospassivo) + parseFloat(val.diferimentospassivo) + parseFloat(val.outrospassivoscorrentes);

            return parseFloat(total).toFixed(2);
        },

        T3T7A() {
            var total = parseFloat(this.T3T5A) + parseFloat(this.T3T6A);

            return parseFloat(total).toFixed(2);
        },
        T3T7B() {
            var total = parseFloat(this.T3T5B) + parseFloat(this.T3T6B);

            return parseFloat(total).toFixed(2);
        },

        T3T8A() {
            var total = parseFloat(this.T3T1A) + parseFloat(this.T3T4A);

            return parseFloat(total).toFixed(2);
        },
        T3T8B() {
            var total = parseFloat(this.T3T1B) + parseFloat(this.T3T4B);

            return parseFloat(total).toFixed(2);
        },
        T3T9A() {
            var total = parseFloat(this.T3T3A) + parseFloat(this.T3T7A);

            return parseFloat(total).toFixed(2);
        },
        T3T9B() {
            var total = parseFloat(this.T3T3B) + parseFloat(this.T3T7B);

            return parseFloat(total).toFixed(2);
        },
        T4T1() {
            var val = this.VALUES.T1A;
            var total = ((parseFloat(val.vendasservicosprestados) - parseFloat(val.cmvcmc)) / parseFloat(val.vendasservicosprestados)) * 100;

            return parseFloat(total).toFixed(1);
        },
        T4T2() {
            var val = this.VALUES.T1A;
            var total = (parseFloat(this.T1T4A) / parseFloat(val.vendasservicosprestados)) * 100;

            return parseFloat(total).toFixed(1);
        },
        T4T3() {
            var total = (parseFloat(this.T1T4A) / parseFloat(this.T3T3A)) * 100;

            return parseFloat(total).toFixed(1);
        },
        T4T4() {
            var total = (parseFloat(this.T1T2A) / parseFloat(this.T3T8A)) * 100;

            return parseFloat(total).toFixed(1);
        },
        T4T5() {
            var total = (parseFloat(this.T3T3A) / parseFloat(this.T3T8A)) * 100;

            return parseFloat(total).toFixed(1);
        },
        T4T6() {
            var total = (parseFloat(this.T3T7A) / parseFloat(this.T3T8A)) * 100;

            return parseFloat(total).toFixed(1);
        },
        T4T7() {
            var val = this.VALUES.T1A;
            var total = (parseFloat(this.VALUES.T3A.clientes) / parseFloat(val.vendasservicosprestados)) * 365;

            return parseFloat(total).toFixed(1);
        },
        T4T8() {
            var total = (parseFloat(this.VALUES.T3A.fornecedores) / (parseFloat(this.VALUES.T1A.cmvcmc) + parseFloat(this.VALUES.T1A.fse))) * 365;

            return parseFloat(total).toFixed(1);
        },
        T4T9() {
            var total = (parseFloat(this.VALUES.T1A.vendasservicosprestados) / parseFloat(this.T3T8A));

            return parseFloat(total).toFixed(1);
        },
        T4T10() {
            var total = (parseFloat(this.T3T4A) / parseFloat(this.T3T6A));

            return parseFloat(total).toFixed(1);
        },
        T4T11() {
            var total = ((parseFloat(this.T3T4A) - this.VALUES.T3A.inventarios) / parseFloat(this.T3T6A));
            
            return parseFloat(total).toFixed(1);
        },
        T4T12() {
            var total = (parseFloat(this.VALUES.T3A.caixaedepositosbancarios) / parseFloat(this.T3T6A));

            return parseFloat(total).toFixed(1);
        },
        AtivosTangiveisA() {
            var total = parseFloat(this.VALUES.T3A.ativostangiveis) - parseFloat(this.VALUES.T1A.gastosreversoesdepreciacao)

            return parseFloat(total).toFixed(2);
        },
        AtivosTangiveisB() {
            var total = parseFloat(this.VALUES.T3B.ativostangiveis) - parseFloat(this.VALUES.T1B.gastosreversoesdepreciacao)

            return parseFloat(total).toFixed(2);
        },
        AtivosIntangiveisA() {
            var total = parseFloat(this.VALUES.T3A.ativosintangiveis) - parseFloat(this.VALUES.T1A.gastosreversoesdeamortizacao)

            return parseFloat(total).toFixed(2);
        },
        AtivosIntangiveisB() {
            var total = parseFloat(this.VALUES.T3B.ativosintangiveis) - parseFloat(this.VALUES.T1B.gastosreversoesdeamortizacao)

            return parseFloat(total).toFixed(2);
        }
    },

    watch: {
        modal(val) {
            val || this.close()
        },
        dialog(val) {
            val || this.close()
        },
        deleteM(val) {
            val || this.close()
        },
        getAll(val) {
            this.initialize()
        },
        email(val) {
            if (val && this.editedIndex > -1 && this.path) {
                this.E.email = this.editedItem.email;
                this.E.assunto = 'Relatório Gestão - ' + this.meses.find((el) => {
                    return el.mes == this.mes
                }).nome + '/' + this.ano
                this.E.corpo = 'Segue o link para consultar o relatório relativo a ' + this.meses.find((el) => {
                    return el.mes == this.mes
                }).nome + '/' + this.ano;
                this.E.link = this.path;
            }
        }
    },

    created() {
        this.defaultRules = [v => !!v || this.$requiredField + ''];
        this.pwdRules = [v => v == this.editedItem.password || '* As palavras-passe não coincidem!'];
        this.initialize();

        this.ano = Number(this.$moment().format('YYYY'));
        this.mes = Number(this.$moment().format('M'));

        this.STRINGS[1] = 'De referir que face aos resultados obtidos, prevê-se que haja lugar ao apuramento de IRC no montante de € {#####,##}. Neste montante estão incluídos € ####,## referente às tributações autónomas relacionadas com ajudas de custo, despesas de representação e encargos com viaturas ligeiras de passageiros.';
        this.STRINGS[2] = `Relativamente às próximas obrigações fiscais, ainda face a ${this.ano}, relembramos que existe em ###, ###, ###, pagamento por conta de € ####,## cada.`;
        this.STRINGS[3] = 'A conta de sócios apresenta um saldo devedor de € ####,##.'
        this.STRINGS[4] = 'Texto exemplo';
        this.STRINGS[5] = 'Texto exemplo';

        this.imgToBase64(this.logo, (base64) => {
            this.base64Img = base64;
        })

    },
    mounted() {

    },
    methods: {
        numberWithSpaces(x) {
            var parts = x.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return parts.join(".");
        },

        changeP21() {

            setTimeout(() => {
                var str = this.STRINGS[1];
                
                var str1 = str.split('{')[0];
                var str2 = str.split('{')[1].split('}')[1];

                this.STRINGS[1] = str1 + '{' + this.numberWithSpaces(this.VALUES.T1A.impostosrp) + '}' + str2;

                this.$forceUpdate();
            }, 1000);
        },

        toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },

        gerarPassword() {
            this.editedItem.password = this.generatePassword();
            this.cpwd = this.editedItem.password;
        },

        generatePassword() {
            var length = 8,
                charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
                retVal = "";
            for (var i = 0, n = charset.length; i < length; ++i) {
                retVal += charset.charAt(Math.floor(Math.random() * n));
            }
            return retVal;
        },

        formatValue(value) {
            return Number.isNaN(value) || value == 0 ? '0' : parseFloat(value).toFixed(2)
        },

        sendMail() {
            this.$store.dispatch('utilizadores/email', this.E).then((res) => {
                if (res) this.toast('success', 'E-mail enviado com sucesso.');
                else this.toast('error', 'Não foi possível enviar o e-mail.');

                this.email = false;
            })
        },

        getBase64(value, scale, x, y) {
            /*return this.$html2canvas(document.querySelector("#" + value),{
                scrollX: 0,
                scrollY: 0
            }).then(canvas => {
                return {
                    width: canvas.width,
                    height: canvas.height,
                    scale: scale,
                    x: x,
                    y: y,
                    canvas: canvas.toDataURL('image/png', 0.1)
                }
            }); */

            return this.$html2canvas(document.querySelector("#" + value),{
                letterRendering: true,
                onclone: (doc) => {
                    
                    return new Promise((resolve, reject) => {
                        setTimeout(() => {
                            resolve()
                        }, 400)
                    })
                }
            }).then(canvas => {
                return {
                    width: canvas.width,
                    height: canvas.height,
                    scale: scale,
                    x: x,
                    y: y,
                    canvas: canvas.toDataURL('image/png', 0.1)
                }
            });


            /*var element = document.querySelector("#" + value);
            
            return this.$htmlToImage.toCanvas(element)
                .then((canvas) => {

                    return {
                        width: canvas.width,
                        height: canvas.height,
                        scale: scale,
                        x: x,
                        y: y,
                        canvas: canvas.toDataURL('image/png', 0.1)
                    }
                }); */
        },

        imgToBase64(url, callback, imgVariable) {

            if (!window.FileReader) {
                callback(null);
                return;
            }
            var xhr = new XMLHttpRequest();
            xhr.responseType = 'blob';
            xhr.onload = function () {
                var reader = new FileReader();
                reader.onloadend = function () {
                    imgVariable = reader.result.replace('text/xml', 'image/jpeg');
                    callback(imgVariable);
                };
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.send();
        },

        docFooter(doc, pageNumber, totalPages) {
            doc.setFontSize(10);
            doc.text(pageNumber + '/' + totalPages, doc.internal.pageSize.width - margin - 5, doc.internal.pageSize.height - margin);
        },

        docHeader(doc, str) {
            doc.setFontSize(13);
            doc.setTextColor(40);
            doc.setFontStyle('normal');

            doc.addImage(this.base64Img, 'JPEG', doc.internal.pageSize.width - margin * 3, margin / 2, 20, 12);
            doc.text(str, margin, margin + 5);
            doc.line(margin, margin + 7, doc.internal.pageSize.width - margin, margin + 7); // horizontal line
        },

        headerFooterFormatting(doc, totalPages) {
            var headers = [
                '',
                String(this.editedItem.codigo).toUpperCase() + ' R.G_' + this.mes + this.ano +' 1 - Informações',
                String(this.editedItem.codigo).toUpperCase() + ' R.G_' + this.mes + this.ano +' 2 - Actividade',
                String(this.editedItem.codigo).toUpperCase() + ' R.G_' + this.mes + this.ano +' 2 - Actividade',
                String(this.editedItem.codigo).toUpperCase() + ' R.G_' + this.mes + this.ano +' 3 - Análise Patrimonial',
                String(this.editedItem.codigo).toUpperCase() + ' R.G_' + this.mes + this.ano +' 4 - Indicadores económico - financeiros',
                String(this.editedItem.codigo).toUpperCase() + ' R.G_' + this.mes + this.ano +' 4 - Indicadores económico - financeiros'
            ];

            for (var i = 1; i <= totalPages; i++) {
                if(i>1) {
                    doc.setPage(i);
                    this.docHeader(doc, String(headers[i - 1])); 
                    this.docFooter(doc, i, totalPages);
                }

                if (i < totalPages) doc.addPage();
            }

            return doc;
        },

        addImageToPage(doc, page, image, x, y, w, h) {
            doc.setPage(page);
            doc.addImage(image, 'PNG', x, y, w, h, '', 'FAST');

            return doc;
        },

        async exportar() {
            this.loader = true;

            var doc = new jsPDF('p', 'mm');
            var totalPages = 7;
            doc = await this.headerFooterFormatting(doc, totalPages);
            var imgWidth = doc.internal.pageSize.width - margin * 2;

            // -- CAPA
            doc.setPage(1);
            doc.addImage(this.base64Img, 'JPEG', (doc.internal.pageSize.width/2) - 30, (doc.internal.pageSize.height/2 )- 50, 20*3, 12*3);
            doc.setFontSize(20);
            doc.setFontStyle('bold');
            doc.text('Relatório de Gestão Periódico', (doc.internal.pageSize.width/2), (doc.internal.pageSize.height/2 ), 'center');
            doc.text(this.editedItem.nome, (doc.internal.pageSize.width/2), (doc.internal.pageSize.height/2 ) + 15, 'center');

            doc.setFontSize(15);
            doc.setFontStyle('normal');
            doc.text(String(this.meses.find((el)=>{ return el.mes == this.mes }).nome + ' - ' +this.ano), (doc.internal.pageSize.width/2), (doc.internal.pageSize.height/2 ) + 40, 'center');

            doc.setFontSize(10);
            doc.text('Póvoa de Varzim \nRua Padre José Brenha, 74 \n4490-669 PVZ \nTlf: 252 004 348', margin, doc.internal.pageSize.height - margin*2, 'left');
            doc.text('Porto \nRua do Tronco, 375 Sala N1.1 \n4465-275 S.Mamede de Infesta \nTlf: 229 022 884', (doc.internal.pageSize.width/2), doc.internal.pageSize.height - margin*2, 'center');
            doc.text('Famalicão \nAv.9 de Julho, 462 \n4760-102 V.N.F \nTlf: 252 320 776', doc.internal.pageSize.width - margin, doc.internal.pageSize.height - margin*2, 'right');

            
            // - PAGE 1
            var P1 = await this.getBase64('P1', 0.9, margin, margin * 3);
            doc = await this.addImageToPage(doc, 2, P1.canvas, P1.x, P1.y, imgWidth * P1.scale, P1.height * imgWidth * P1.scale / P1.width);

            var P2 = await this.getBase64('P2', 0.9, margin, P1.y * 3);
            doc = await this.addImageToPage(doc, 2, P2.canvas, P2.x, P2.y, imgWidth * P2.scale, P2.height * imgWidth * P2.scale / P2.width);

            // -- Page 2
            var T1 = await this.getBase64('T1', 1, margin, margin * 3);
            doc = await this.addImageToPage(doc, 3, T1.canvas, T1.x, T1.y, imgWidth * T1.scale, T1.height * imgWidth * T1.scale / T1.width);

            // -- PAGE 3
            var CH1 = await this.getBase64('CH1', 0.48, margin, margin * 3);
            doc = await this.addImageToPage(doc, 4, CH1.canvas, CH1.x, CH1.y, imgWidth * CH1.scale, CH1.height * imgWidth * CH1.scale / CH1.width);

            var CH2 = await this.getBase64('CH2', 0.48, (doc.internal.pageSize.width / 2), margin * 3);
            doc = await this.addImageToPage(doc, 4, CH2.canvas, CH2.x, CH2.y, imgWidth * CH2.scale, CH2.height * imgWidth * CH2.scale / CH2.width);

            var CH3 = await this.getBase64('CH3', 0.48, margin, CH2.y * 3);
            doc = await this.addImageToPage(doc, 4, CH3.canvas, CH3.x, CH3.y, imgWidth * CH3.scale, CH3.height * imgWidth * CH3.scale / CH3.width);

            var CH4 = await this.getBase64('CH4', 0.48, (doc.internal.pageSize.width / 2), CH2.y * 3);
            doc = await this.addImageToPage(doc, 4, CH4.canvas, CH4.x, CH4.y, imgWidth * CH4.scale, CH4.height * imgWidth * CH4.scale / CH4.width);

            var CH5 = await this.getBase64('CH5', 0.48, margin, CH2.y * 5);
            doc = await this.addImageToPage(doc, 4, CH5.canvas, CH5.x, CH5.y, imgWidth * CH5.scale, CH5.height * imgWidth * CH5.scale / CH5.width);

            var T2 = await this.getBase64('T2', 0.48, (doc.internal.pageSize.width / 2), CH2.y * 5);
            doc = await this.addImageToPage(doc, 4, T2.canvas, T2.x, T2.y, imgWidth * T2.scale, T2.height * imgWidth * T2.scale / T2.width);

            // -- PAGE 4
            var T3 = await this.getBase64('T3', 1, margin, margin * 3);
            doc = await this.addImageToPage(doc, 5, T3.canvas, T3.x, T3.y, imgWidth * T3.scale, T3.height * imgWidth * T3.scale / T3.width);

            var CH6 = await this.getBase64('CH6', 0.5, margin, T1.y * 6 + margin);
            doc = await this.addImageToPage(doc, 5, CH6.canvas, CH6.x, CH6.y, imgWidth * CH6.scale, CH6.height * imgWidth * CH6.scale / CH6.width);

            var CH7 = await this.getBase64('CH7', 0.46, (doc.internal.pageSize.width / 2), T1.y * 6 + margin);
            doc = await this.addImageToPage(doc, 5, CH7.canvas, CH7.x, CH7.y, imgWidth * CH7.scale, CH7.height * imgWidth * CH7.scale / CH7.width);

            // PAGE 5
            var T4 = await this.getBase64('T4', 0.5, margin * 5 + 10, margin * 3);
            doc = await this.addImageToPage(doc, 6, T4.canvas, T4.x, T4.y, imgWidth * T4.scale, T4.height * imgWidth * T4.scale / T4.width);

            var T5 = await this.getBase64('T5', 0.6, margin * 4 + 10, margin * 3);
            doc = await this.addImageToPage(doc, 7, T5.canvas, T5.x, T5.y, imgWidth * T5.scale, T5.height * imgWidth * T5.scale / T5.width); 

            let reader = new window.FileReader();
            reader.readAsDataURL(doc.output("blob"));

            reader.onloadend = () => {
                var nome = 'RG_' + String(this.mes) + String(this.ano) + '_' + this.editedItem.codigo +'_' + this.$moment().format('YYYY-MM-DD HH:mm:ss').replace(' ', '_').split('-').join('').split(':').join('');

                this.$store.dispatch('imagens/insert', {
                    nome: nome,
                    id: this.editedItem.codigo,
                    valor: reader.result
                }).then((res) => {
                    if (res) {
                        this.path = this.$fileURL + this.editedItem.codigo + '/Relatórios Gestão/' + nome + '.pdf';

                        window.open(this.path, '_blank');
                        this.loader = false;
                    } else {
                        this.toast('error', 'Não foi possível exportar os dados apresentados.');
                        this.loader = false;
                    }
                });
            } 

            /*
            // - PAGE 1
            this.getBase64('P1', 1, margin, margin * 3).then((P1)=>{
                this.addImageToPage(doc, 2, P1.canvas, P1.x, P1.y, imgWidth * P1.scale, P1.height * imgWidth * P1.scale / P1.width).then((document)=>{
                    doc = document;
                    this.getBase64('P2', 1, margin, P1.y * 3).then((P2)=>{
                        this.addImageToPage(doc, 2, P2.canvas, P2.x, P2.y, imgWidth * P2.scale, P2.height * imgWidth * P2.scale / P2.width).then((document)=>{
                            doc = document;
                            // -- Page 2
                            this.getBase64('T1', 1, margin, margin * 3).then((T1)=>{
                                this.addImageToPage(doc, 3, T1.canvas, T1.x, T1.y, imgWidth * T1.scale, T1.height * imgWidth * T1.scale / T1.width).then((document)=>{
                                    doc = document;
                                    // -- PAGE 3
                                    this.getBase64('CH1', 0.48, margin, margin * 3).then((CH1)=>{
                                        this.addImageToPage(doc, 4, CH1.canvas, CH1.x, CH1.y, imgWidth * CH1.scale, CH1.height * imgWidth * CH1.scale / CH1.width).then((document)=>{
                                            doc = document;
                                            this.getBase64('CH2', 0.48, (doc.internal.pageSize.width / 2), margin * 3).then((CH2)=>{
                                                this.addImageToPage(doc, 4, CH2.canvas, CH2.x, CH2.y, imgWidth * CH2.scale, CH2.height * imgWidth * CH2.scale / CH2.width).then((document)=>{
                                                    doc = document;
                                                    this.getBase64('CH3', 0.48, margin, CH2.y * 3).then((CH3)=>{
                                                        this.addImageToPage(doc, 4, CH3.canvas, CH3.x, CH3.y, imgWidth * CH3.scale, CH3.height * imgWidth * CH3.scale / CH3.width).then((document)=>{
                                                            doc = document;
                                                            this.getBase64('CH4', 0.48, (doc.internal.pageSize.width / 2), CH2.y * 3).then((CH4)=>{
                                                                this.addImageToPage(doc, 4, CH4.canvas, CH4.x, CH4.y, imgWidth * CH4.scale, CH4.height * imgWidth * CH4.scale / CH4.width).then((document)=>{
                                                                    doc = document;
                                                                    this.getBase64('CH5', 0.48, margin, CH2.y * 5).then((CH5)=>{
                                                                        this.addImageToPage(doc, 4, CH5.canvas, CH5.x, CH5.y, imgWidth * CH5.scale, CH5.height * imgWidth * CH5.scale / CH5.width).then((document)=>{
                                                                            doc = document;
                                                                            this.getBase64('T2', 0.48, (doc.internal.pageSize.width / 2), CH2.y * 5).then((T2)=>{
                                                                                this.addImageToPage(doc, 4, T2.canvas, T2.x, T2.y, imgWidth * T2.scale, T2.height * imgWidth * T2.scale / T2.width).then((document)=>{
                                                                                    doc = document;
                                                                                    // -- PAGE 4
                                                                                    this.getBase64('T3', 1, margin, margin * 3).then((T3)=>{
                                                                                        this.addImageToPage(doc, 5, T3.canvas, T3.x, T3.y, imgWidth * T3.scale, T3.height * imgWidth * T3.scale / T3.width).then((document)=>{
                                                                                            doc = document;
                                                                                            this.getBase64('CH6', 0.5, margin, T1.y * 6 + margin).then((CH6)=>{
                                                                                                this.addImageToPage(doc, 5, CH6.canvas, CH6.x, CH6.y, imgWidth * CH6.scale, CH6.height * imgWidth * CH6.scale / CH6.width).then((document)=>{
                                                                                                    doc = document;
                                                                                                    this.getBase64('CH7', 0.46, (doc.internal.pageSize.width / 2), T1.y * 6 + margin).then((CH7)=>{
                                                                                                        this.addImageToPage(doc, 5, CH7.canvas, CH7.x, CH7.y, imgWidth * CH7.scale, CH7.height * imgWidth * CH7.scale / CH7.width).then((document)=>{
                                                                                                            doc = document;
                                                                                                            // PAGE 5
                                                                                                            this.getBase64('T4', 0.5, margin * 5 + 10, margin * 3).then((T4)=>{
                                                                                                                this.addImageToPage(doc, 6, T4.canvas, T4.x, T4.y, imgWidth * T4.scale, T4.height * imgWidth * T4.scale / T4.width).then((document)=>{
                                                                                                                    doc = document;
                                                                                                                    this.getBase64('T5', 0.6, margin * 4 + 10, margin * 3).then((T5)=>{
                                                                                                                        this.addImageToPage(doc, 7, T5.canvas, T5.x, T5.y, imgWidth * T5.scale, T5.height * imgWidth * T5.scale / T5.width).then((document)=>{
                                                                                                                            doc = document;
                                                                                                                            let reader = new window.FileReader();
                                                                                                                            reader.readAsDataURL(doc.output("blob"));

                                                                                                                            reader.onloadend = () => {
                                                                                                                                var nome = 'RG_' + String(this.mes) + String(this.ano) + '_' + this.editedItem.codigo +'_' + this.$moment().format('YYYY-MM-DD HH:mm:ss').replace(' ', '_').split('-').join('').split(':').join('');

                                                                                                                                this.$store.dispatch('imagens/insert', {
                                                                                                                                    nome: nome,
                                                                                                                                    id: this.editedItem.codigo,
                                                                                                                                    valor: reader.result
                                                                                                                                }).then((res) => {
                                                                                                                                    if (res) {
                                                                                                                                        this.path = this.$fileURL + this.editedItem.codigo + '/Relatórios Gestão/' + nome + '.pdf';

                                                                                                                                        window.open(this.path, '_blank');
                                                                                                                                        this.loader = false;
                                                                                                                                    } else {
                                                                                                                                        this.toast('error', 'Não foi possível exportar os dados apresentados.');
                                                                                                                                        this.loader = false;
                                                                                                                                    }
                                                                                                                                });
                                                                                                                            }
                                                                                                                        });
                                                                                                                    });
                                                                                                                });
                                                                                                            });
                                                                                                        });
                                                                                                    });
                                                                                                });
                                                                                            });
                                                                                        });
                                                                                    });
                                                                                });
                                                                            });
                                                                        });
                                                                    });
                                                                });
                                                            });
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            }); 
            */
        },

        getTotalByProperty(array, prop) {
            if (array.length == 0) return 0
            else return array.map((el) => {
                return el[prop]
            }).reduce((a, b) => (parseFloat(String(a).replace(',', '.')) + parseFloat(String(b).replace(',', '.'))).toFixed(2)) + ' €'
        },

        searchData() {
            var url = this.getLinks.rgURL;
            this.loader = true;
            const options = {
                method: 'POST',
                crossDomain: true,
                async: true,
                headers: {
                    'content-type': 'application/x-www-form-urlencoded'
                },
                data: qs.stringify({
                    invocationPassword: this.$servicePWD,
                    cliente: this.editedItem.codigo,
                    ano: this.ano,
                    mesfim: this.mes,
                    mes: ''
                }),
                url,
            };

            axios(options).then((res) => {

                var str = JSON.parse(convert.xml2json(res.data, {
                    compact: true,
                    spaces: 4
                })).string._text;

                var result = JSON.parse("[" + str + "]");

                this.REPORT = Array.isArray(result) ? [].concat(result) : [];

                if (this.REPORT.length == 0) this.toast('error', 'Não foram encontrados resultados para a pesquisa efetuada.');
                else {

                    // -- P1
                    this.VALUES.P1.volnegocios = this.getValues(this.REPORT[0], 'volnegocios');
                    this.VALUES.P1.margembruta = this.getValues(this.REPORT[0], 'margembruta');

                    // -- T1
                    this.VALUES.T1A.vendasservicosprestados = this.getValues(this.REPORT[1], 'vendasservicosprestados');
                    this.VALUES.T1A.subsidiosaexploracao = this.getValues(this.REPORT[1], 'subsidiosaexploracao');
                    this.VALUES.T1A.variacaoinventariosprod = this.getValues(this.REPORT[1], 'variacaoinventariosprod');
                    this.VALUES.T1A.trabalhospropriaentidade = this.getValues(this.REPORT[1], 'trabalhospropriaentidade');
                    this.VALUES.T1A.cmvcmc = this.getValues(this.REPORT[1], 'cmvcmc');
                    this.VALUES.T1A.fse = this.getValues(this.REPORT[1], 'fse');
                    this.VALUES.T1A.gastoscompessoal = this.getValues(this.REPORT[1], 'gastoscompessoal');
                    this.VALUES.T1A.gastosreversoesdepreciacao = this.getValues(this.REPORT[1], 'gastosreversoesdepreciacao');
                    this.VALUES.T1A.gastosreversoesdeamortizacao = this.getValues(this.REPORT[1], 'gastosreversoesdeamortizacao');
                    this.VALUES.T1A.imparidade = this.getValues(this.REPORT[1], 'imparidade');
                    this.VALUES.T1A.provisoes = this.getValues(this.REPORT[1], 'provisoes');
                    this.VALUES.T1A.outrosrendimentosganhos = this.getValues(this.REPORT[1], 'outrosrendimentosganhos');
                    this.VALUES.T1A.outrosgastosperdas = this.getValues(this.REPORT[1], 'outrosgastosperdas');
                    this.VALUES.T1A.saldoconta79 = this.getValues(this.REPORT[1], 'saldoconta79');
                    this.VALUES.T1A.saldoconta69 = this.getValues(this.REPORT[1], 'saldoconta69');
                    this.VALUES.T1A.gastoliquidofinanciamento = this.getValues(this.REPORT[1], 'gastoliquidofinanciamento');
                    this.VALUES.T1A.impostosrp = this.getValues(this.REPORT[1], 'impostosrp');

                    // -- CH1
                    this.VALUES.CH1.MESES = this.REPORT[2].map((el) => {
                        return el.mes
                    });
                    this.VALUES.CH1.EMV = this.REPORT[2].map((el) => {
                        return parseFloat(parseFloat(el.vendas.replace(',', '.')).toFixed(2))
                    });
                    this.VALUES.CH1.CMVMC = this.REPORT[2].map((el) => {
                        return parseFloat(parseFloat(el.cmvmc.replace(',', '.')).toFixed(2))
                    });
                    this.VALUES.CH1.MB = this.REPORT[2].map((el) => {
                        return parseFloat(parseFloat(el.margembruta.replace(',', '.')).toFixed(2))
                    });

                    // -- CH2
                    this.VALUES.CH2.MESES = this.REPORT[2].map((el) => {
                        return el.mes
                    });
                    this.VALUES.CH2.FSEM = this.REPORT[2].map((el) => {
                        return parseFloat(parseFloat(el.fsemaisoutrosgastos.replace(',', '.')).toFixed(2))
                    });
                    this.VALUES.CH2.OG = this.REPORT[2].map((el) => {
                        return parseFloat(parseFloat(el.outrosgastos.replace(',', '.')).toFixed(2))
                    });
                    this.VALUES.CH2.MB = this.REPORT[2].map((el) => {
                        return parseFloat(parseFloat(el.margembruta.replace(',', '.')).toFixed(2))
                    });

                    // -- CH3
                    this.VALUES.CH3.MESES = this.REPORT[2].map((el) => {
                        return el.mes
                    });
                    this.VALUES.CH3.FSEM = this.REPORT[2].map((el) => {
                        return parseFloat(parseFloat(el.fsemaisoutrosgastos.replace(',', '.')).toFixed(2))
                    });
                    this.VALUES.CH3.FSE = this.REPORT[2].map((el) => {
                        return parseFloat(parseFloat(el.fse.replace(',', '.')).toFixed(2))
                    });
                    this.VALUES.CH3.OG = this.REPORT[2].map((el) => {
                        return parseFloat(parseFloat(el.outrosgastos.replace(',', '.')).toFixed(2))
                    });

                    // -- CH4
                    this.VALUES.CH4.MESES = this.REPORT[3].map((el) => {
                        return el.mes
                    });
                    this.VALUES.CH4.C68 = this.REPORT[3].map((el) => {
                        return parseFloat(parseFloat(el.conta68.replace(',', '.')).toFixed(2))
                    });
                    this.VALUES.CH4.C69 = this.REPORT[3].map((el) => {
                        return parseFloat(parseFloat(el.conta69.replace(',', '.')).toFixed(2))
                    });
                    this.VALUES.CH4.C6869 = this.REPORT[3].map((el) => {
                        return parseFloat(parseFloat(el.contas68e69.replace(',', '.')).toFixed(2))
                    });

                    // -- CH5
                    this.VALUES.CH5.ORDEM = this.REPORT[4].map((el) => {
                        return el.ordem
                    });
                    this.VALUES.CH5.G = this.REPORT[4].map((el) => {
                        return parseFloat(parseFloat(el.saldo.replace(',', '.')).toFixed(2))
                    });
                    this.VALUES.CH5.TABELA = this.REPORT[4];

                    // -- T3
                    this.VALUES.T3A.saldo11 = this.getValues(this.REPORT[5], 'saldo11');
                    this.VALUES.T3A.saldo12 = this.getValues(this.REPORT[5], 'saldo12');
                    this.VALUES.T3A.saldo13 = this.getValues(this.REPORT[5], 'saldo13');
                    this.VALUES.T3A.saldo14ativo = this.getValues(this.REPORT[5], 'saldo14ativo');
                    this.VALUES.T3A.clientes = this.getValues(this.REPORT[5], 'clientes');
                    this.VALUES.T3A.fornecedores = this.getValues(this.REPORT[5], 'fornecedores');
                    this.VALUES.T3A.saldo23passivo = this.getValues(this.REPORT[5], 'saldo23passivo');
                    this.VALUES.T3A.estadooutrosentespublicospassivo = this.getValues(this.REPORT[5], 'estadooutrosentespublicospassivo');
                    this.VALUES.T3A.financiamentosobtidos = this.getValues(this.REPORT[5], 'financiamentosobtidos');
                    this.VALUES.T3A.saldo27passivo = this.getValues(this.REPORT[5], 'saldo27passivo');
                    this.VALUES.T3A.inventarios = this.getValues(this.REPORT[5], 'inventarios');
                    this.VALUES.T3A.investimentosfinanceiros = this.getValues(this.REPORT[5], 'investimentosfinanceiros');
                    this.VALUES.T3A.saldo43 = this.getValues(this.REPORT[5], 'saldo43');
                    this.VALUES.T3A.saldo44 = this.getValues(this.REPORT[5], 'saldo44');
                    this.VALUES.T3A.capitalrealizado = this.getValues(this.REPORT[5], 'capitalrealizado');
                    this.VALUES.T3A.reservas = this.getValues(this.REPORT[5], 'reservas');
                    this.VALUES.T3A.resultadostransitados = this.getValues(this.REPORT[5], 'resultadostransitados');
                    this.VALUES.T3A.diferimentosativo = this.getValues(this.REPORT[5], 'diferimentosativo');
                    this.VALUES.T3A.ativostangiveis = this.getValues(this.REPORT[5], 'ativostangiveis');
                    this.VALUES.T3A.ativosintangiveis = this.getValues(this.REPORT[5], 'ativosintangiveis');
                    this.VALUES.T3A.outrosativoscorrentes = this.getValues(this.REPORT[5], 'outrosativoscorrentes');
                    this.VALUES.T3A.outrospassivoscorrentes = this.getValues(this.REPORT[5], 'outrospassivoscorrentes');
                    this.VALUES.T3A.caixaedepositosbancarios = this.getValues(this.REPORT[5], 'caixaedepositosbancarios');
                    this.VALUES.T3A.outrasvariacoescapitalproprio = this.getValues(this.REPORT[5], 'outrasvariacoescapitalproprio');
                    this.VALUES.T3A.outrosintrumentoscapitalproprio = this.getValues(this.REPORT[5], 'outrosintrumentoscapitalproprio');
                    this.VALUES.T3A.estadooutrosentespublicosativo = this.getValues(this.REPORT[5], 'estadooutrosentespublicosativo');
                    this.VALUES.T3A.diferimentospassivo = this.getValues(this.REPORT[5], 'diferimentospassivo');
                    this.VALUES.T3A.provisoes = this.getValues(this.REPORT[5], 'provisoes');

                    this.VALUES.T3A.displayCH6 = true;
                    this.VALUES.T3A.displayCH7 = true;

                    //this.$forceUpdate();

                }
                this.dialog = true;
                this.loader = false;
            }).catch((err) => {
                //console.log(err);
                this.loader = false;
                this.toast('error', 'Não foram encontrados resultados para a pesquisa efetuada.');
            })
        },

        getDiffT1(field) {
            var a = parseFloat(this.VALUES.T1A[field]) > 0;
            var total = a ? parseFloat(String(this.VALUES.T1A[field]).replace('-','')) - parseFloat(String(this.VALUES.T1B[field]).replace('-','')) : null;

            return total != null ? parseFloat(total).toFixed(2) : '-';
        },

        getPercentT1(field) {
            var a = parseFloat(this.VALUES.T1A[field]) > 0;
            var total = a ? parseFloat(this.getDiffT1(field) * 100) / parseFloat(String(this.VALUES.T1B[field]).replace('-','')) : null;

            return total != null && Number.isFinite(total) ? this.numberWithSpaces(parseFloat(total).toFixed(2)) : '-';
        },

        getDiffTotal(field) {
            if (field == '1') {
                return parseFloat(parseFloat(String(this.T1T1A).replace('-','')) - parseFloat(String(this.T1T1B).replace('-',''))).toFixed(2);
            } else if (field == '2') {
                return parseFloat(parseFloat(String(this.T1T2A).replace('-','')) - parseFloat(String(this.T1T2B).replace('-',''))).toFixed(2);
            } else if (field == '3') {
                return parseFloat(parseFloat(String(this.T1T3A).replace('-','')) - parseFloat(String(this.T1T3B).replace('-',''))).toFixed(2);
            } else if (field == '4') {
                return parseFloat(parseFloat(String(this.T1T4A).replace('-','')) - parseFloat(String(this.T1T4B).replace('-',''))).toFixed(2);
            }
        },

        getPercentTotal(field) {
            var total = 0;
            if (field == '1') {
                total = (parseFloat(this.getDiffTotal(field)).toFixed(2) * 100 / parseFloat((parseFloat(String(this.T1T1A).replace('-','')))));
            } else if (field == '2') {
                total = (parseFloat(this.getDiffTotal(field)).toFixed(2) * 100 / parseFloat((parseFloat(String(this.T1T2A).replace('-','')))));
            } else if (field == '3') {
                total = (parseFloat(this.getDiffTotal(field)).toFixed(2) * 100 / parseFloat((parseFloat(String(this.T1T3A).replace('-','')))));
            } else if (field == '4') {
                total = (parseFloat(this.getDiffTotal(field)).toFixed(2) * 100 / parseFloat((parseFloat(String(this.T1T4A).replace('-','')))));
            }


            return Number.isFinite(total) ? parseFloat(total).toFixed(2) : 0.00;
        },

        getValues(array, field) {
            var val = array.find((el) => {
                return el.nomecampo == field
            });

            return typeof val == 'undefined' ? 0 : parseFloat((val.valorcampo).replace('-', '').replace(',', '.')).toFixed(2);
        },

        initialize() {
            this.loading = true;
            this.DATA = this.getAll;
            this.loading = false;
        },

        editItem(item, dialog) {
            this.editedIndex = this.DATA.indexOf(item);
            this.editedItem = Object.assign({}, item);

            if (dialog) this.modal = true;
            else this.deleteM = true;
        },

        gerar() {
            this.form = false;
            this.searchData();
        },

        getReport(item) {
            this.editedIndex = this.DATA.indexOf(item);
            this.editedItem = Object.assign({}, item);

            this.form = true;
            //this.$eventBus.$emit("relatorio", item.codigo);
        },

        delete() {
            if (!this.editedItem.id_utilizador) return;

            this.$store
                .dispatch(this.table + "/delete", {
                    id: this.editedItem.id_utilizador
                })
                .then((res) => {
                    if (res) {
                        this.toast('success', this.messages.delete.success);
                        this.initialize();
                    } else this.toast('error', this.messages.delete.error);

                    this.deleteM = false;
                });
        },

        close() {
            this.modal = this.deleteM = this.dialog = this.form = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;

                this.path = null;
                this.E = {};
                this.VALUES = Object.assign({}, this.defaultValues);

                this.$refs.form.reset();
            }, 110);
        },

        save() {

            if (this.deleteM) {
                this.delete();
                return;
            }

            if (!this.$refs.form.validate()) return;

            if (this.editedIndex == -1) {
                this.$store
                    .dispatch(this.table + "/insert", {
                        nome: this.editedItem.nome,
                        email: this.editedItem.email,
                        password: this.editedItem.password,
                        codigo: String(this.editedItem.codigo).toUpperCase(),
                        ano: this.editedItem.ano,
                        urlwebsite: this.editedItem.urlwebsite,
                        pastas: this.editedItem.pastas,
                        nif: this.editedItem.nif,
                        super: 0,
                        ativo: 1,
                        anos2: this.editedItem.anos2,
                        escritorio: this.editedItem.id_escritorio,
                        telefone: this.editedItem.telefone
                    })
                    .then((res) => {
                        if (res) {
                            this.toast('success', this.messages.add.success);
                            this.initialize();
                        } else this.toast('error', this.messages.add.error);

                        this.modal = false;
                    });
            } else {
                this.$store
                    .dispatch(this.table + "/update", {
                        id: this.editedItem.id_utilizador,
                        nome: this.editedItem.nome,
                        email: this.editedItem.email,
                        codigo: String(this.editedItem.codigo).toUpperCase(),
                        ano: this.editedItem.ano,
                        urlwebsite: this.editedItem.urlwebsite,
                        pastas: this.editedItem.pastas,
                        nif: this.editedItem.nif,
                        super: 0,
                        ativo: 1,
                        anos2: this.editedItem.anos2,
                        escritorio: this.editedItem.id_escritorio,
                        telefone: this.editedItem.telefone
                    })
                    .then((res) => {
                        if (res) {
                            this.toast('success', this.messages.update.success);
                            this.initialize();
                        } else this.toast('error', this.messages.update.error);

                        this.modal = false;
                    });
            }
        }
    }
}
</script>

<style scoped>
#report p i {
    color: #000 !important;
    margin-right: 10px !important;
    margin-bottom: 3px;
}

#report .r-header i {
    font-size: 14px !important;
}

#report .r-child i {
    font-size: 11px !important;
}

#report .r-header {
    font-size: 15px !important;
    padding: 0 !important;
}

#report .r-child {
    font-size: 13px !important;
    padding: 0 !important;
    padding-left: 30px !important;
}

#report .bold-up {
    text-transform: uppercase !important;
    font-weight: 600 !important;
    white-space: pre !important;
}

#report tr:nth-child(odd) {
    background-color: #f5f5f5 !important;
}

#report table {
    border-spacing: 0px !important;
}

#report td,
#report th {
    padding: 10px !important;
}

#report .table-left {
    text-align: left !important;
}

#report .table-right {
    text-align: right !important;
    font-weight: 600 !important;
}

#P1,
#P2 {
    max-width: 70% !important;
}

#T1,
#T2,
#T3,
#T4,
#T5 {
    padding: 0 20px !important;
}

#P2 {
    text-align: justify !important;
}


.bola {
    position: absolute;
    border-radius: 50px;
    height: 10px;
    width: 10px;
    right: 20%;
}

.bola-verde {
    background-color: green;
}

.bola-vermelha {
    background-color: red;
}

.bola-laranja {
    background-color: orange;
}

.aceite {
    color: green !important;
}

.naceite {
    color: red !important;
}

.linha-indicadores {
    position: relative !important;
    display: flex !important;
    align-items:  center !important;
    align-items: center !important;
    justify-content: flex-end !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tables/Table_Clientes.vue